import { Button, DatePicker, Input, Select, Table } from "antd"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { columns, EProgramBookingStatus, programBookingStatusToTextMap, statusTagColor, textToProgramBookingStatusMap, useGetAllProgramBookingAdminByProgramId, useGetProgramTitleById, useUpdateProgramBookingStatusAdminByUpdateProgramBookingStatusRequest } from "./model"
import dayjs, { Dayjs } from "dayjs"
import { CSVLink } from "react-csv"

const ProgramBooking = () => {
    const programId = Number(useParams().id)
    const [fillteredData, setFillteredData] = useState<IProgramApplyForList[]>()
    const [fillterTargetDatePeriod, setFillterTargetDatePeriod] = useState<[Dayjs | undefined, Dayjs | undefined]>([undefined, undefined])
    const [fillterStatus, setFillterStatus] = useState<0 | EProgramBookingStatus>(0);
    const [fillterSearch, setFillterSearch] = useState<string>('');
    const { data: programData } = useGetProgramTitleById(programId)
    const { data, isFetching } = useGetAllProgramBookingAdminByProgramId(programId)
    const [adminProgramBooking, setAdminProgramBooking] = useState<string>('');

    const onFillterClick = () => {
        const filteredList = data?.filter((item) => {
            const statusMatch = fillterStatus === 0 || item.status === fillterStatus;
            const nameAndMobileMatch = fillterSearch === '' || item.memberName.includes(fillterSearch) || item.memberMobile.includes(fillterSearch);
            const targetDateMatch = !fillterTargetDatePeriod[0] || !fillterTargetDatePeriod[1] ? true : (dayjs(item.targetDateTime).isAfter(fillterTargetDatePeriod[0].startOf('d')) && dayjs(item.targetDateTime).isBefore(fillterTargetDatePeriod[1].endOf('d')));
            return statusMatch && nameAndMobileMatch && targetDateMatch;
        })
        setFillteredData(filteredList)
    }

    const convertDataToCsvData = (data?: IProgramApplyForList[]) => {
        return data?.map((item) => ({
            id: item.id,
            "이름": item.memberName,
            "전화번호": item.memberMobile,
            "프로그램 이용일시": dayjs(item.targetDateTime).format('YYYY.MM.DD HH:mm'),
            "상태": item.status,
            "결제금액": item.paidAmount,
        })) ?? []
    }

    const onClickAdminProgramBooking = () => {

    }

    useEffect(() => {
        onFillterClick()
    }, [fillterTargetDatePeriod, fillterSearch, fillterStatus, isFetching])

    return <>
        <div style={{ paddingBottom: '56px' }}>
            <div style={{ display: 'flex', width: '50%', paddingBottom: '24px' }}>
                <div style={{ height: '32px', flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '32px' }}>
                    프로그램
                </div>
                <div style={{ height: '32px', flex: 3, fontWeight: 600, fontSize: '14px', lineHeight: '32px' }}>
                    {programData?.title}
                </div>
            </div>
            <div style={{ display: 'flex', paddingBottom: '24px' }}>
                <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                        프로그램 이용일
                    </div>
                    <div style={{ flex: 3 }}>
                        <DatePicker.RangePicker defaultValue={fillterTargetDatePeriod} style={{ width: '398px' }} onChange={q => (q && q[0] && q[1]) && setFillterTargetDatePeriod([q[0], q[1]])} />
                    </div>
                </div>
                <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                        예약 상태
                    </div>
                    <div style={{ flex: 3 }}>
                        <Select defaultValue={fillterStatus} value={fillterStatus} onChange={setFillterStatus} style={{ width: '406px' }}>
                            <Select.Option value={0}>전체</Select.Option>
                            {Object.values(EProgramBookingStatus).map((q) => <Select.Option key={q} value={programBookingStatusToTextMap[q]}>{programBookingStatusToTextMap[q]}</Select.Option>)}
                        </Select>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', paddingBottom: '24px' }}>
                <div style={{ width: '50%', display: 'flex' }}>
                    <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '32px' }}>
                        검색
                    </div>
                    <div style={{ flex: 3 }}>
                        <Input style={{ width: '406px' }} placeholder="이름 또는 휴대폰번호 검색" defaultValue={fillterSearch} value={fillterSearch} onPressEnter={onFillterClick} onChange={e => setFillterSearch(e.target.value)} />
                    </div>
                </div>
                <Button type='primary' onClick={onFillterClick} >검색</Button>
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '32px' }}>
            <div>
                검색 결과 ({fillteredData?.length})
            </div>
            <Button>
                <CSVLink filename={"프로그램-" + fillteredData?.[0]?.programTitle?.replaceAll(' ', '') + '-' + dayjs().format("YYYY-MM-DD HH_mm_ss")} data={convertDataToCsvData(fillteredData)}>CSV 다운로드</CSVLink>
            </Button>
        </div>
        {process.env.REACT_APP_ENV === 'local' && <div>
            <div onClick={onClickAdminProgramBooking} style={{ height: '32px', paddingInline: '6px', backgroundColor: 'var(--ant-color-primary)', color: 'var(--ant-color-bg-base)', borderRadius: '4px', lineHeight: '32px' }}>
                관리자 예약
            </div>
            <div>
                <Input.TextArea value={adminProgramBooking} onChange={e => setAdminProgramBooking(e.target.value)} />
            </div>
        </div>}
        <Table loading={isFetching} dataSource={fillteredData} rowKey={'id'} columns={columns} />
    </>
}

export { ProgramBooking }
